import React from 'react';

function AbsenteesModal({
  isOpen = false,
  onClose = () => {},
  dateLabel,
  totalCount = 0,
  onLeaveMembers = [],
  absentMembers = [],
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-60 backdrop-blur-sm transition-opacity"
          onClick={onClose}
        ></div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full">
          <div className="bg-gradient-to-r from-rose-500 to-orange-500 px-6 py-6 text-white">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h3 className="text-2xl font-bold">Today’s Absentees</h3>
                <p className="mt-1 text-sm text-rose-100">
                  {dateLabel} • {totalCount} total
                </p>
                <div className="mt-3 flex flex-wrap gap-2 text-xs font-semibold">
                  <span className="rounded-full bg-white/20 px-3 py-1">
                    On Leave {onLeaveMembers.length}
                  </span>
                  <span className="rounded-full bg-white/20 px-3 py-1">
                    Absent {absentMembers.length}
                  </span>
                </div>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="ml-4 inline-flex items-center justify-center h-10 w-10 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white"
              >
                <span className="text-xl font-bold leading-none">&times;</span>
              </button>
            </div>
          </div>

          <div className="bg-white px-6 py-6 max-h-[70vh] overflow-y-auto space-y-6">
            <section>
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-lg font-bold text-gray-900">On Leave</h4>
                <span className="text-sm text-gray-500">{onLeaveMembers.length} member{onLeaveMembers.length === 1 ? '' : 's'}</span>
              </div>
              {onLeaveMembers.length === 0 ? (
                <div className="rounded-xl border border-dashed border-gray-200 bg-gray-50 px-4 py-6 text-center text-sm text-gray-500">
                  No approved leave today.
                </div>
              ) : (
                <div className="space-y-3">
                  {onLeaveMembers.map((member) => (
                    <div key={member.id || member.email} className="rounded-xl border border-rose-100 bg-rose-50/60 p-4">
                      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                        <div>
                          <div className="font-semibold text-gray-900">{member.name}</div>
                          <div className="text-sm text-gray-600">{member.email || 'No email provided'}</div>
                          <div className="text-sm text-gray-600">{member.department}</div>
                        </div>
                        <div className="text-sm text-gray-700 sm:text-right">
                          <div className="font-semibold text-rose-700">{member.leaveType}</div>
                          <div>{member.leaveStartDate} to {member.leaveEndDate}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </section>

            <section>
              <div className="flex items-center justify-between mb-3">
                <h4 className="text-lg font-bold text-gray-900">Absent</h4>
                <span className="text-sm text-gray-500">{absentMembers.length} member{absentMembers.length === 1 ? '' : 's'}</span>
              </div>
              {absentMembers.length === 0 ? (
                <div className="rounded-xl border border-dashed border-gray-200 bg-gray-50 px-4 py-6 text-center text-sm text-gray-500">
                  No absent users today.
                </div>
              ) : (
                <div className="space-y-3">
                  {absentMembers.map((member) => (
                    <div key={member.id || member.email} className="rounded-xl border border-orange-100 bg-orange-50/60 p-4">
                      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                        <div>
                          <div className="font-semibold text-gray-900">{member.name}</div>
                          <div className="text-sm text-gray-600">{member.email || 'No email provided'}</div>
                          <div className="text-sm text-gray-600">{member.department}</div>
                        </div>
                        <div className="text-sm font-semibold text-orange-700">Absent today</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </section>
          </div>

          <div className="bg-gray-50 px-6 py-4 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-semibold rounded-lg text-white bg-gradient-to-r from-rose-500 to-orange-500 hover:from-rose-600 hover:to-orange-600 focus:outline-none focus:ring-2 focus:ring-rose-400"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AbsenteesModal;
